export default "__VITE_ASSET__3d415d37__"